<script lang="ts">
    import {getModalContext} from './modal-context';
    import {getLocalization} from 'core/svelte-context/context';
    import {createEventDispatcher} from 'svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let defaultClose = true;

    const context = getModalContext();
    const localize = getLocalization();
    const dispatch = createEventDispatcher<{ 'close': void }>();

    const handleCloseClick = () => {
        if (defaultClose) {
            context.modalWindowActions.cancel();
            return;
        }

        dispatch('close');
    }
</script>

<button type="button"
        class="close"
        data-dismiss="modal"
        title="{localize(/* @kp-localization commons.zavrit */ 'commons.zavrit')}"
        aria-label="{localize(/* @kp-localization commons.zavrit */ 'commons.zavrit')}"
        on:click={handleCloseClick}>
    <UIcon icon="cross-circle"/>
</button>
